import { render, staticRenderFns } from "./M2hP1.vue?vue&type=template&id=0a178dfa&scoped=true&"
import script from "./M2hP1.vue?vue&type=script&lang=js&"
export * from "./M2hP1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a178dfa",
  null
  
)

export default component.exports